// Constants
import constants from '../constants'
// Logo Images
import { viemaxImgUrls } from './viemax-constants'

// Signup Components
import IdentifyUser from '../containers/AnayaCare/Components/IdentifyUser'
import Gender from '../components/Signup/Gender'
import DateOfBirth from '../components/Signup/DateOfBirth'
import FullName from '../components/Signup/FullName'
import DoctorLocation from '../containers/AnayaCare/Components/DoctorLocation'
import UploadDocuments from '../containers/AnayaCare/Components/UploadDocuments'

export const ANAYA_CONFIG = {
  id: constants.CARE_PROGRAM_TYPE.ANAYA,
  name: 'Anaya Care Program',
  drug_name: 'Anaya',
  campaign_link: `${process.env.REACT_APP_FE_URL}/programs/anaya-care`,
  medical_condition_group_id: null, // need to ask Ankur
  upload_report_type: 'dp',
  onboarding_steps: [
    {
      name: 'userType',
      hideButton: true,
      Component: IdentifyUser,
    },
    {
      name: 'name',
      hideButton: true,
      Component: FullName,
      title: 'Enter patient’s name',
      subtitle: 'We will refer to you by this name in the application.',
    },
    {
      name: 'gender',
      hideButton: true,
      Component: Gender,
      title: 'What is patient’s gender?',
      subtitle: 'We ask your gender to ensure personalised support.',
    },
    {
      name: 'dob',
      hideButton: true,
      Component: DateOfBirth,
      title: 'Patient’s date of birth?',
      subtitle: 'We ask your DOB to personalise your care based on your age.',
    },
    {
      name: 'address',
      hideButton: true,
      Component: DoctorLocation,
    },
    {
      name: 'uploadDocuments',
      hideButton: true,
      hideImage: true,
      bg: '#F2F2F2',
      Component: UploadDocuments,
    },
  ],
  success_image: viemaxImgUrls.successImageWithWoman,
  success_image_width: 220,
  logoWhite: viemaxImgUrls.logoWhite,
  partnerName: 'Anaya',
  success_message: () => (
    <>
      Powered by <b>GoodFlip</b> in partnership with
      <br /> <b>Anaya</b>. Your trusted health partner.
    </>
  ),
}
